import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_4 = { align: "center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_6 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Consolidated Balance", -1)
const _hoisted_8 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_9 = { align: "center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_11 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_12 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_13 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_14 = { align: "center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_16 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  EC Wallet", -1)
const _hoisted_18 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_19 = { align: "center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_21 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  MG Pay", -1)
const _hoisted_23 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_24 = { align: "center" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1)
const _hoisted_26 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  PGI", -1)
const _hoisted_28 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_29 = { align: "center" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_31 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Product GC", -1)
const _hoisted_33 = {
  style: {"display":"none"},
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_34 = { align: "center" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_36 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Miss iGlow Codes", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 2,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loadingBalance]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _withDirectives(_createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.balancedetails.overAllAvailableBalance).toFixed(2))) + " " + _toDisplayString(_ctx.balancedetails.currency), 1)
            ]),
            _hoisted_7
          ], 512), [
            [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo']
          ]),
          _withDirectives(_createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.balancedetails.balance).toFixed(2))) + " " + _toDisplayString(_ctx.balancedetails.currency), 1)
            ]),
            _createVNode("div", _hoisted_12, "  " + _toDisplayString(_ctx.user.usid) + " Balance", 1)
          ], 512), [
            [_vShow, !_ctx.loadingBalance ]
          ]),
          _withDirectives(_createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.balancedetails.ewalletbalance).toFixed(2))) + " " + _toDisplayString(_ctx.balancedetails.currency == 'ZAR' ? 'PHP' :  _ctx.balancedetails.currency), 1)
            ]),
            _hoisted_17
          ], 512), [
            [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo']
          ]),
          _withDirectives(_createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", _hoisted_21, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.balancedetails.matchinpaybalance).toFixed(2))) + " " + _toDisplayString(_ctx.balancedetails.currency), 1)
            ]),
            _hoisted_22
          ], 512), [
            [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.ccode === 0]
          ]),
          _withDirectives(_createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("div", _hoisted_26, _toDisplayString(_ctx.balancedetails.travelgc), 1)
            ]),
            _hoisted_27
          ], 512), [
            [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo']
          ]),
          _withDirectives(_createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("div", _hoisted_31, _toDisplayString(_ctx.balancedetails.productgc), 1)
            ]),
            _hoisted_32
          ], 512), [
            [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo']
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode("div", _hoisted_36, _toDisplayString(_ctx.votingPower), 1)
            ]),
            _hoisted_37
          ])
        ], 512), [
          [_vShow, !_ctx.loadingBalance]
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}